import React, { useState, useEffect } from 'react';
import ApiService from '../../services/api';
import { Receipt , Briefcase , MonitorCog , SquareActivity , Tickets , Menu, X, Home, Package, FileText, Calendar, Users, BarChart3, Settings, Bell, Search, ChevronDown, ArrowRight, TrendingUp, TrendingDown, Building, Hammer, Truck, Star, AlertCircle, CheckCircle, Clock, DollarSign, Activity, Globe, Zap, Target, Award, Shield, LogOut, ChevronRight, Filter, Download, RefreshCw, MoreVertical, Plus, User, Edit, Trash2, Eye, Package2, Layers, Wrench, ShoppingCart, Box, Hash, Grid, Cpu, Router, Network, HardDrive, Server, MonitorSpeaker, Radio, Wifi, Database, CircuitBoard, Power, PlugZap, UserCog, Calculator, Construction, Beaker, Leaf, ShieldCheck, Ruler, Square, Triangle, Hexagon, Maximize2, Move3D, Shapes, MapPin, Footprints, Zap as ZapIcon, Wind, Sparkles, Paintbrush, Gauge, QrCode, Folder, LampFloor as FloorPlan, Palette, Scissors, Droplets, Thermometer, Volume2, Grip, Text as Texture, Warehouse } from 'lucide-react';
import '../../Styles/products.css';
import { useNavigate } from "react-router-dom";
import MepIcon from '../../assets/MEP_Solutions.png';
import architecturalIcon from '../../assets/architectural_icon.png';
import civilIcon from '../../assets/civil-icon.png';
import constructionIcon from '../../assets/construction-icon.png';
import powerToolsIcon from '../../assets/power-tools_icon.png';
import sustainableIcon from '../../assets/sustainable-icon.png';
import hygienicIcon from '../../assets/hygienic-icon.png';
import '../../Styles/dashboard.css';
import * as XLSX from 'xlsx';

const UnitechCommercialFlooringSolutionsPage = () => {
    const [user, setUser] = useState(null);
    const [isAuthChecking, setIsAuthChecking] = useState(true);
    const [sidebarOpen, setSidebarOpen] = useState(true);
    const [activeMenuItem, setActiveMenuItem] = useState('hygienic_solutions');
    const [currentTime, setCurrentTime] = useState(new Date());
    const [notifications, setNotifications] = useState(3);
    const [isLoading, setIsLoading] = useState(false);
    const [selectedCategory, setSelectedCategory] = useState('');
    const [searchTerm, setSearchTerm] = useState('');
    const [sortBy, setSortBy] = useState('productId');
    const [sortOrder, setSortOrder] = useState('asc');
    const [showEditModal, setShowEditModal] = useState(false);
    const [showViewModal, setShowViewModal] = useState(false);
    const [selectedFlooringProduct, setSelectedFlooringProduct] = useState(null);
    const navigate = useNavigate();

    const [flooringProducts, setFlooringProducts] = useState([]);
    const [categories, setCategories] = useState([]);
    const [pagination, setPagination] = useState({
        page: 1,
        pages: 1,
        total: 0
    });
    const [error, setError] = useState(null);

    const [showAddModal, setShowAddModal] = useState(false);
    const [formData, setFormData] = useState({
        barcodeNumber: '',
        productId: '',
        description: '',
        flooringType: 'vinyl',
        thickness: '',
        dimensions: '',
        wearLayer: '',
        fireRating: 'Class_A',
        slipResistance: 'R9',
        acousticRating: '',
        installation: 'glue_down',
        warranty: '10_years',
        standard: 'EN_14041'
    });
    const [formError, setFormError] = useState('');
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        loadCurrentUser();
    }, []);

    useEffect(() => {
        if (user) {
            loadFlooringProducts();
        }
    }, [user]);

    useEffect(() => {
        if (user) {
            // Reset pagination when search/sort changes
            setPagination(prev => ({ ...prev, page: 1 }));

            const timeoutId = setTimeout(() => {
                loadFlooringProducts();
            }, searchTerm ? 300 : 100);

            return () => clearTimeout(timeoutId);
        }
    }, [user, searchTerm, sortBy, sortOrder]);

    useEffect(() => {
        if (user && pagination.page) {
            console.log('🔄 Flooring pagination page changed to:', pagination.page);
            loadFlooringProducts();
        }
    }, [pagination.page]);

    useEffect(() => {
        const timer = setInterval(() => {
            setCurrentTime(new Date());
        }, 1000);
        return () => clearInterval(timer);
    }, []);

    const loadCurrentUser = async () => {
        try {
            setIsAuthChecking(true);

            const syncUser = ApiService.getUserSync();
            if (syncUser) {
                setUser(syncUser);
                setIsAuthChecking(false);
                return;
            }

            const response = await ApiService.getCurrentUser();
            if (response.success && response.user) {
                setUser(response.user);
            } else {
                navigate('/login');
            }
        } catch (error) {
            console.error('Failed to load user:', error);
            navigate('/login');
        } finally {
            setIsAuthChecking(false);
        }
    };

    const loadFlooringProducts = async () => {
        try {
            setIsLoading(true);
            setError(null);

            const params = {
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                page: pagination.page || 1,
                limit: 20
            };

            // Remove undefined params
            Object.keys(params).forEach(key => {
                if (params[key] === undefined) {
                    delete params[key];
                }
            });

            console.log('🔄 Loading flooring products with params:', params);

            const response = await ApiService.getCommercialFlooringSolutions(params);

            console.log('📡 Flooring API Response:', response);

            if (response.success || response.products || response.data) {
                let productsArray = [];

                // Handle different response formats
                if (Array.isArray(response.products)) {
                    productsArray = response.products;
                } else if (Array.isArray(response.data)) {
                    productsArray = response.data;
                } else if (Array.isArray(response)) {
                    productsArray = response;
                }

                console.log('📦 Flooring products found:', productsArray.length);
                console.log('📄 Current page:', pagination.page);

                setFlooringProducts(productsArray);

                // Update pagination
                const total = response.total || response.count || productsArray.length;
                const limit = response.limit || params.limit || 20;
                const pages = Math.max(1, Math.ceil(total / limit));

                console.log('📊 Flooring pagination info - Total:', total, 'Limit:', limit, 'Pages:', pages);

                setPagination(prev => ({
                    ...prev,
                    total: total,
                    pages: pages,
                    limit: limit
                }));

                setError(null);
            } else {
                console.error('❌ Flooring API Error:', response.message || 'Unknown error');
                setFlooringProducts([]);
                setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
                setError(response.message || "Erreur lors du chargement des solutions de revêtement commercial");
            }
        } catch (error) {
            console.error('💥 Load flooring products error:', error);
            setFlooringProducts([]);
            setError(error.message || "Erreur lors du chargement des solutions de revêtement commercial");
            setPagination(prev => ({ ...prev, total: 0, pages: 1 }));
        } finally {
            setIsLoading(false);
        }
    };

    const handleRefresh = () => {
        loadFlooringProducts();
    };

    const openAddModal = () => {
        setShowAddModal(true);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            flooringType: 'vinyl',
            thickness: '',
            dimensions: '',
            wearLayer: '',
            fireRating: 'Class_A',
            slipResistance: 'R9',
            acousticRating: '',
            installation: 'glue_down',
            warranty: '10_years',
            standard: 'EN_14041'
        });
    };

    const closeAddModal = () => {
        setShowAddModal(false);
        setFormError('');
        setFormData({
            barcodeNumber: '',
            productId: '',
            description: '',
            flooringType: 'vinyl',
            thickness: '',
            dimensions: '',
            wearLayer: '',
            fireRating: 'Class_A',
            slipResistance: 'R9',
            acousticRating: '',
            installation: 'glue_down',
            warranty: '10_years',
            standard: 'EN_14041'
        });
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({
            ...prev,
            [name]: value
        }));
    };

    const handleAddFlooringProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                flooringType: formData.flooringType,
                thickness: formData.thickness,
                dimensions: formData.dimensions,
                wearLayer: formData.wearLayer,
                fireRating: formData.fireRating,
                slipResistance: formData.slipResistance,
                acousticRating: formData.acousticRating,
                installation: formData.installation,
                warranty: formData.warranty,
                standard: formData.standard
            };

            const response = await ApiService.createCommercialFlooringSolution(productData);

            if (response.success) {
                alert('Solution de revêtement commercial créée avec succès ! 🎉');
                closeAddModal();
                loadFlooringProducts();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la création du produit');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleDeleteFlooringProduct = async (productId) => {
        if (window.confirm('Êtes-vous sûr de vouloir supprimer cette solution de revêtement commercial ?')) {
            try {
                setIsLoading(true);
                const response = await ApiService.deleteCommercialFlooringSolution(productId);
                if (response.success) {
                    loadFlooringProducts();
                    alert('Solution de revêtement commercial supprimée avec succès');
                }
            } catch (error) {
                console.error('Failed to delete commercial flooring solution:', error);
                alert('Erreur lors de la suppression du produit: ' + error.message);
            } finally {
                setIsLoading(false);
            }
        }
    };

    const handleLogout = async () => {
        if (window.confirm('Are you sure you wanna disconnect?')) {
            ApiService.clearUserData();
            navigate('/login');
        }
    };

    const menuItems = [
        {
            id: 'barcoding',
            label: 'Barcoding Database',
            icon: FileText,
            path: '/barcoding'
        },
        {
            id: 'mep-solutions',
            label: 'MEP Solutions',
            icon: MepIcon,
            isImage: true,
            path: '/mep_solutions'
        },
        {
            id: 'architectural-solutions',
            label: 'Architectural Solutions',
            icon: architecturalIcon,
            isImage: true,
            path: '/architectural_solutions'
        },
        {
            id: 'civil-solutions',
            label: 'Civil Solutions',
            icon: civilIcon,
            isImage: true,
            path: '/civil_solutions'
        },
        {
            id: 'construction-chemicals',
            label: 'Construction Chemicals',
            icon: constructionIcon,
            isImage: true,
            path: '/construction_chemicals'
        },
        {
            id: 'power-tools',
            label: 'Power & Industrial Tools',
            icon: powerToolsIcon,
            isImage: true,
            path: '/power_tools'
        },
        {
            id: 'sustainable-solutions',
            label: 'Sustainable Solutions',
            icon: sustainableIcon,
            isImage: true,
            path: '/sustainable_solutions'
        },
        {
            id: 'hygienic-solutions',
            label: 'Hygienic Solutions',
            icon: hygienicIcon,
            isImage: true,
            path: '/hygienic_solutions'
        },
        {
            id: 'conversions',
            label: 'Engineering Conversions',
            icon: Calculator,
            path: '/conversion'
        },
        {
            id: 'analytics',
            label: 'Amazon Products',
            icon: BarChart3,
            path: '/amazon_products'
        },
        {
            id: 'team',
            label: 'Team Management',
            icon: Users,
            path: '/team_management'
        },
        {
            id: 'user-management',
            label: 'User Management',
            icon: UserCog,
            path: '/users_management'
        },
    ];

    const filteredMenuItems = menuItems.filter(item => {
        if (item.id === 'team' && user?.role === 'user') return false;
        if (item.id === 'settings' && user?.role !== 'admin') return false;
        return true;
    });

    const getUserInitials = () => {
        if (!user) return 'U';
        const firstInitial = user.firstName ? user.firstName.charAt(0).toUpperCase() : '';
        const lastInitial = user.lastName ? user.lastName.charAt(0).toUpperCase() : '';
        return firstInitial + lastInitial || user.email.charAt(0).toUpperCase();
    };

    const getDisplayName = () => {
        if (!user) return 'Utilisateur';
        if (user.firstName && user.lastName) {
            return `${user.firstName} ${user.lastName}`;
        }
        return user.email;
    };

    const getFlooringTypeIcon = (type) => {
        const iconMap = {
            'vinyl': Layers,
            'laminate': Texture,
            'carpet': Grip,
            'hardwood': Warehouse,
            'ceramic': Square,
            'epoxy': Droplets,
            'rubber': Footprints,
            'linoleum': FloorPlan,
            'concrete': Construction,
            'bamboo': Leaf
        };
        return iconMap[type] || FloorPlan;
    };

    const flooringTypeOptions = [
        { value: 'vinyl', label: 'Vinyl Flooring' },
        { value: 'laminate', label: 'Laminate Flooring' },
        { value: 'carpet', label: 'Commercial Carpet' },
        { value: 'hardwood', label: 'Engineered Hardwood' },
        { value: 'ceramic', label: 'Ceramic Tiles' },
        { value: 'epoxy', label: 'Epoxy Flooring' },
        { value: 'rubber', label: 'Rubber Flooring' },
        { value: 'linoleum', label: 'Linoleum' },
        { value: 'concrete', label: 'Polished Concrete' },
        { value: 'bamboo', label: 'Bamboo Flooring' }
    ];

    const fireRatingOptions = [
        'Class_A', 'Class_B', 'Class_C', 'Class_1', 'Class_2', 'Bfl_s1', 'Cfl_s1'
    ];

    const slipResistanceOptions = [
        'R9', 'R10', 'R11', 'R12', 'R13', 'A', 'B', 'C'
    ];

    const installationOptions = [
        { value: 'glue_down', label: 'Glue Down' },
        { value: 'click_lock', label: 'Click Lock' },
        { value: 'loose_lay', label: 'Loose Lay' },
        { value: 'nail_down', label: 'Nail Down' },
        { value: 'floating', label: 'Floating Installation' },
        { value: 'adhesive_strips', label: 'Adhesive Strips' }
    ];

    const warrantyOptions = [
        '5_years', '10_years', '15_years', '20_years', '25_years', 'lifetime'
    ];

    const standardOptions = [
        'EN_14041', 'ASTM_F1700', 'ISO_10874', 'EN_649', 'ASTM_E648', 'EN_13501'
    ];

    if (isAuthChecking) {
        return (
            <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '100vh',
                flexDirection: 'column'
            }}>
                <RefreshCw style={{ width: '24px', height: '24px', animation: 'spin 1s linear infinite' }} />
                <p style={{ marginTop: '16px' }}>Vérification de l'authentification...</p>
            </div>
        );
    }

    if (!user) {
        return null;
    }

    const openViewModal = (product) => {
        setSelectedFlooringProduct(product);
        setShowViewModal(true);
    };

    const closeViewModal = () => {
        setShowViewModal(false);
        setSelectedFlooringProduct(null);
    };

    const openEditModal = (product) => {
        setSelectedFlooringProduct(product);
        setFormData({
            barcodeNumber: product.barcodeNumber,
            productId: product.productId,
            description: product.description || '',
            flooringType: product.flooringType || 'vinyl',
            thickness: product.thickness || '',
            dimensions: product.dimensions || '',
            wearLayer: product.wearLayer || '',
            fireRating: product.fireRating || 'Class_A',
            slipResistance: product.slipResistance || 'R9',
            acousticRating: product.acousticRating || '',
            installation: product.installation || 'glue_down',
            warranty: product.warranty || '10_years',
            standard: product.standard || 'EN_14041'
        });
        setFormError('');
        setShowEditModal(true);
    };

    const closeEditModal = () => {
        setShowEditModal(false);
        setSelectedFlooringProduct(null);
        setFormError('');
    };

    const handleEditFlooringProduct = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setFormError('');

        try {
            if (!formData.barcodeNumber || !formData.productId || !formData.description) {
                throw new Error('Veuillez remplir tous les champs obligatoires');
            }

            const productData = {
                barcodeNumber: formData.barcodeNumber,
                productId: formData.productId,
                description: formData.description,
                flooringType: formData.flooringType,
                thickness: formData.thickness,
                dimensions: formData.dimensions,
                wearLayer: formData.wearLayer,
                fireRating: formData.fireRating,
                slipResistance: formData.slipResistance,
                acousticRating: formData.acousticRating,
                installation: formData.installation,
                warranty: formData.warranty,
                standard: formData.standard
            };

            const response = await ApiService.updateCommercialFlooringSolution(selectedFlooringProduct._id, productData);

            if (response.success) {
                alert('Solution de revêtement commercial mise à jour avec succès !');
                closeEditModal();
                loadFlooringProducts();
            }
        } catch (error) {
            setFormError(error.message || 'Erreur lors de la mise à jour');
        } finally {
            setIsSubmitting(false);
        }
    };

    const handleExportCommercialFlooring = async () => {
        try {
            setIsLoading(true);
            alert('Preparing commercial flooring solutions export...');

            const exportParams = {
                search: searchTerm.trim() || undefined,
                sortBy,
                sortOrder,
                export: true,
                limit: 10000
            };

            Object.keys(exportParams).forEach(key => {
                if (exportParams[key] === undefined) {
                    delete exportParams[key];
                }
            });

            const response = await ApiService.getCommercialFlooringSolutions(exportParams);

            if (response.success || response.products || response.data) {
                let productsToExport = [];

                if (Array.isArray(response.products)) {
                    productsToExport = response.products;
                } else if (Array.isArray(response.data)) {
                    productsToExport = response.data;
                } else if (Array.isArray(response)) {
                    productsToExport = response;
                }

                const exportData = productsToExport.map((product, index) => ({
                    'No.': index + 1,
                    'Barcode Number': product.barcodeNumber || '',
                    'Product ID': product.productId || '',
                    'Flooring Type': product.flooringType?.replace('_', ' ') || '',
                    'Thickness': product.thickness || '',
                    'Dimensions': product.dimensions || '',
                    'Wear Layer': product.wearLayer || '',
                    'Fire Rating': product.fireRating?.replace('_', ' ') || '',
                    'Slip Resistance': product.slipResistance || '',
                    'Acoustic Rating': product.acousticRating || '',
                    'Installation': product.installation?.replace('_', ' ') || '',
                    'Warranty': product.warranty?.replace('_', ' ') || '',
                    'Standard': product.standard?.replace('_', ' ') || '',
                    'Description': product.description || '',
                    'Created Date': product.createdAt ? new Date(product.createdAt).toLocaleDateString('fr-FR') : '',
                    'Last Updated': product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : ''
                }));

                await exportCommercialFlooringToExcel(exportData, productsToExport.length);

            } else {
                throw new Error('No commercial flooring data to export');
            }
        } catch (error) {
            console.error('Commercial flooring export failed:', error);
            alert('Export failed: ' + error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const exportCommercialFlooringToExcel = async (data, totalCount) => {
        try {
            const ws = {};
            const headers = Object.keys(data[0] || {});

            headers.forEach((header, index) => {
                const cellRef = String.fromCharCode(65 + index) + '1';
                ws[cellRef] = { v: header, t: 's' };
            });

            data.forEach((row, rowIndex) => {
                headers.forEach((header, colIndex) => {
                    const cellRef = String.fromCharCode(65 + colIndex) + (rowIndex + 2);
                    const value = row[header];
                    ws[cellRef] = { v: value, t: typeof value === 'number' ? 'n' : 's' };
                });
            });

            const range = `A1:${String.fromCharCode(65 + headers.length - 1)}${data.length + 1}`;
            ws['!ref'] = range;

            const wb = {
                Sheets: { 'Commercial Flooring Solutions': ws },
                SheetNames: ['Commercial Flooring Solutions']
            };

            const wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
            const blob = new Blob([wbout], { type: 'application/octet-stream' });
            const url = URL.createObjectURL(blob);
            const link = document.createElement('a');

            const today = new Date().toISOString().split('T')[0];
            const filename = `UNITECH-Commercial-Flooring-Solutions_${today}.xlsx`;

            link.href = url;
            link.download = filename;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            URL.revokeObjectURL(url);

            alert(`Successfully exported ${totalCount} commercial flooring solutions to Excel! 🎉`);

        } catch (error) {
            console.error('Excel generation failed:', error);
            throw new Error('Failed to generate Excel file');
        }
    };

    const showNotification = (message, type = 'info', duration = 3000) => {
        // Simple notification implementation
        console.log(`${type.toUpperCase()}: ${message}`);
    };

    return (
        <div className="dashboard-container">
            {/* ADD FLOORING PRODUCT MODAL */}
            {showAddModal && (
                <div style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white',
                        borderRadius: '12px',
                        padding: '24px',
                        width: '90%',
                        maxWidth: '800px',
                        maxHeight: '90vh',
                        overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Modal Header */}
                        <div style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            marginBottom: '24px',
                            paddingBottom: '16px',
                            borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px',
                                    height: '40px',
                                    backgroundColor: '#7c3aed',
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}>
                                    <FloorPlan style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Add Commercial Flooring Solution
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        Create a new commercial flooring product
                                    </p>
                                </div>
                            </div>
                            <button
                                onClick={closeAddModal}
                                style={{
                                    padding: '8px',
                                    border: 'none',
                                    background: 'none',
                                    cursor: 'pointer',
                                    borderRadius: '6px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error Message */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2',
                                border: '1px solid #fecaca',
                                color: '#dc2626',
                                padding: '12px',
                                borderRadius: '8px',
                                marginBottom: '20px',
                                fontSize: '14px',
                                display: 'flex',
                                alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* Form */}
                        <form onSubmit={showEditModal ? handleEditFlooringProduct : handleAddFlooringProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Row 1: Barcode Number and Product ID */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Numéro de Code-barres *
                                        </label>
                                        <input
                                            type="text"
                                            name="barcodeNumber"
                                            value={formData.barcodeNumber}
                                            onChange={handleInputChange}
                                            placeholder="1234567890123"
                                            required
                                            maxLength="13"
                                            pattern="[0-9]{13}"
                                            title="The barcode should be a 13-digit number."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text"
                                            name="productId"
                                            value={formData.productId}
                                            onChange={handleInputChange}
                                            placeholder="CFS-VIN-001"
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 2: Flooring Type and Thickness */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <FloorPlan style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Type de Revêtement *
                                        </label>
                                        <select
                                            name="flooringType"
                                            value={formData.flooringType}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {flooringTypeOptions.map(type => (
                                                <option key={type.value} value={type.value}>
                                                    {type.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Ruler style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Épaisseur
                                        </label>
                                        <input
                                            type="text"
                                            name="thickness"
                                            value={formData.thickness}
                                            onChange={handleInputChange}
                                            placeholder="2.5mm, 4mm, 6mm..."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 3: Dimensions and Wear Layer */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Maximize2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Dimensions
                                        </label>
                                        <input
                                            type="text"
                                            name="dimensions"
                                            value={formData.dimensions}
                                            onChange={handleInputChange}
                                            placeholder="1220x180mm, 600x600mm..."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Layers style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Couche d'Usure
                                        </label>
                                        <input
                                            type="text"
                                            name="wearLayer"
                                            value={formData.wearLayer}
                                            onChange={handleInputChange}
                                            placeholder="0.3mm, 0.5mm, 0.7mm..."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>
                                </div>

                                {/* Row 4: Fire Rating and Slip Resistance */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Shield style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Classement Feu *
                                        </label>
                                        <select
                                            name="fireRating"
                                            value={formData.fireRating}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {fireRatingOptions.map(rating => (
                                                <option key={rating} value={rating}>
                                                    {rating.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Grip style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Résistance au Glissement *
                                        </label>
                                        <select
                                            name="slipResistance"
                                            value={formData.slipResistance}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {slipResistanceOptions.map(resistance => (
                                                <option key={resistance} value={resistance}>
                                                    {resistance}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 5: Acoustic Rating and Installation */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Volume2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Classement Acoustique
                                        </label>
                                        <input
                                            type="text"
                                            name="acousticRating"
                                            value={formData.acousticRating}
                                            onChange={handleInputChange}
                                            placeholder="ΔRw 15dB, IIC 65..."
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        />
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Wrench style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Type d'Installation *
                                        </label>
                                        <select
                                            name="installation"
                                            value={formData.installation}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {installationOptions.map(installation => (
                                                <option key={installation.value} value={installation.value}>
                                                    {installation.label}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 6: Warranty and Standard */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <Award style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Garantie *
                                        </label>
                                        <select
                                            name="warranty"
                                            value={formData.warranty}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {warrantyOptions.map(warranty => (
                                                <option key={warranty} value={warranty}>
                                                    {warranty.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>

                                    <div>
                                        <label style={{
                                            display: 'block',
                                            fontSize: '14px',
                                            fontWeight: '500',
                                            color: '#374151',
                                            marginBottom: '6px'
                                        }}>
                                            <ShieldCheck style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Standard *
                                        </label>
                                        <select
                                            name="standard"
                                            value={formData.standard}
                                            onChange={handleInputChange}
                                            required
                                            style={{
                                                width: '100%',
                                                padding: '12px',
                                                border: '1px solid #d1d5db',
                                                borderRadius: '8px',
                                                fontSize: '14px',
                                                boxSizing: 'border-box'
                                            }}
                                        >
                                            {standardOptions.map(standard => (
                                                <option key={standard} value={standard}>
                                                    {standard.replace('_', ' ')}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>

                                {/* Row 7: Description */}
                                <div>
                                    <label style={{
                                        display: 'block',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        color: '#374151',
                                        marginBottom: '6px'
                                    }}>
                                        <FileText style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                        Description *
                                    </label>
                                    <textarea
                                        name="description"
                                        value={formData.description}
                                        onChange={handleInputChange}
                                        placeholder="Detailed description of the commercial flooring solution including features, applications, and benefits."
                                        required
                                        rows="4"
                                        maxLength="1000"
                                        style={{
                                            width: '100%',
                                            padding: '12px',
                                            border: '1px solid #d1d5db',
                                            borderRadius: '8px',
                                            fontSize: '14px',
                                            boxSizing: 'border-box',
                                            resize: 'vertical'
                                        }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{
                                display: 'flex',
                                gap: '12px',
                                marginTop: '24px',
                                paddingTop: '20px',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                <button
                                    type="button"
                                    onClick={showEditModal ? closeEditModal : closeAddModal}
                                    style={{
                                        flex: 1,
                                        padding: '12px 20px',
                                        border: '1px solid #d1d5db',
                                        background: 'white',
                                        color: '#374151',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: 'pointer'
                                    }}
                                >
                                    Cancel
                                </button>
                                <button
                                    type="submit"
                                    disabled={isSubmitting}
                                    style={{
                                        flex: 2,
                                        padding: '12px 20px',
                                        border: 'none',
                                        background: isSubmitting ? '#9ca3af' : (showEditModal ? '#f59e0b' : '#7c3aed'),
                                        color: 'white',
                                        borderRadius: '8px',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        cursor: isSubmitting ? 'not-allowed' : 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '8px'
                                    }}
                                >
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            {showEditModal ? 'Updating...' : 'Creating...'}
                                        </>
                                    ) : (
                                        <>
                                            <FloorPlan style={{ width: '16px', height: '16px' }} />
                                            {showEditModal ? 'Update' : 'Create Product'}
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* VIEW FLOORING PRODUCT MODAL */}
            {showViewModal && selectedFlooringProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '700px', maxHeight: '90vh', overflow: 'auto'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#0ea5e9',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Eye style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600' }}>
                                        Commercial Flooring Details
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedFlooringProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeViewModal} style={{ padding: '8px', border: 'none', background: 'none', cursor: 'pointer' }}>
                                <X style={{ width: '20px', height: '20px' }} />
                            </button>
                        </div>

                        {/* Details */}
                        <div style={{ display: 'grid', gap: '16px' }}>
                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CODE-BARRES</label>
                                    <p style={{ margin: 0, fontSize: '16px', fontWeight: '600', fontFamily: 'monospace' }}>
                                        {selectedFlooringProduct.barcodeNumber}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>PRODUCT ID</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.productId}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>TYPE DE REVÊTEMENT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {flooringTypeOptions.find(t => t.value === selectedFlooringProduct.flooringType)?.label || selectedFlooringProduct.flooringType}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>ÉPAISSEUR</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.thickness || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DIMENSIONS</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.dimensions || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>COUCHE D'USURE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.wearLayer || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CLASSEMENT FEU</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.fireRating?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>RÉSISTANCE AU GLISSEMENT</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.slipResistance || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CLASSEMENT ACOUSTIQUE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.acousticRating || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>INSTALLATION</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {installationOptions.find(i => i.value === selectedFlooringProduct.installation)?.label || selectedFlooringProduct.installation}
                                    </p>
                                </div>
                            </div>

                            <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>GARANTIE</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.warranty?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                                <div>
                                    <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>STANDARD</label>
                                    <p style={{ margin: 0, fontSize: '14px', fontWeight: '500' }}>
                                        {selectedFlooringProduct.standard?.replace('_', ' ') || 'N/A'}
                                    </p>
                                </div>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>DESCRIPTION</label>
                                <p style={{ margin: 0, fontSize: '14px', lineHeight: '1.5' }}>
                                    {selectedFlooringProduct.description}
                                </p>
                            </div>

                            <div>
                                <label style={{ fontSize: '12px', fontWeight: '500', color: '#6b7280' }}>CREATED ON</label>
                                <p style={{ margin: 0, fontSize: '14px' }}>
                                    {selectedFlooringProduct.createdAt ? new Date(selectedFlooringProduct.createdAt).toLocaleDateString('fr-FR') : 'N/A'}
                                </p>
                            </div>
                        </div>

                        <button onClick={closeViewModal} style={{
                            width: '100%', padding: '12px', marginTop: '20px',
                            border: '1px solid #d1d5db', background: 'white',
                            borderRadius: '8px', cursor: 'pointer'
                        }}>
                            Close
                        </button>
                    </div>
                </div>
            )}

            {/* EDIT FLOORING PRODUCT MODAL */}
            {showEditModal && selectedFlooringProduct && (
                <div style={{
                    position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
                    backgroundColor: 'rgba(0, 0, 0, 0.6)', display: 'flex',
                    alignItems: 'center', justifyContent: 'center', zIndex: 1000
                }}>
                    <div style={{
                        backgroundColor: 'white', borderRadius: '12px', padding: '24px',
                        width: '90%', maxWidth: '800px', maxHeight: '90vh', overflow: 'auto',
                        boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.3)'
                    }}>
                        {/* Header */}
                        <div style={{
                            display: 'flex', justifyContent: 'space-between', alignItems: 'center',
                            marginBottom: '24px', paddingBottom: '16px', borderBottom: '2px solid #e5e7eb'
                        }}>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
                                <div style={{
                                    width: '40px', height: '40px', backgroundColor: '#f59e0b',
                                    borderRadius: '8px', display: 'flex', alignItems: 'center', justifyContent: 'center'
                                }}>
                                    <Edit style={{ width: '20px', height: '20px', color: 'white' }} />
                                </div>
                                <div>
                                    <h2 style={{ margin: 0, fontSize: '20px', fontWeight: '600', color: '#111827' }}>
                                        Modifier Solution de Revêtement Commercial
                                    </h2>
                                    <p style={{ margin: 0, fontSize: '14px', color: '#6b7280' }}>
                                        {selectedFlooringProduct.productId}
                                    </p>
                                </div>
                            </div>
                            <button onClick={closeEditModal} style={{
                                padding: '8px', border: 'none', background: 'none', cursor: 'pointer', borderRadius: '6px'
                            }}>
                                <X style={{ width: '20px', height: '20px', color: '#6b7280' }} />
                            </button>
                        </div>

                        {/* Error */}
                        {formError && (
                            <div style={{
                                backgroundColor: '#fef2f2', border: '1px solid #fecaca',
                                color: '#dc2626', padding: '12px', borderRadius: '8px',
                                marginBottom: '20px', fontSize: '14px', display: 'flex', alignItems: 'center'
                            }}>
                                <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                                {formError}
                            </div>
                        )}

                        {/* EDIT FORM - Same structure as add form */}
                        <form onSubmit={handleEditFlooringProduct}>
                            <div style={{ display: 'grid', gap: '20px' }}>
                                {/* Same form fields as add modal */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Hash style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Barcode Number *
                                        </label>
                                        <input
                                            type="text" name="barcodeNumber" value={formData.barcodeNumber} onChange={handleInputChange} required
                                            maxLength="13" pattern="[0-9]{13}"
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            <Package2 style={{ width: '16px', height: '16px', display: 'inline', marginRight: '6px' }} />
                                            Product ID *
                                        </label>
                                        <input
                                            type="text" name="productId" value={formData.productId} onChange={handleInputChange} required
                                            style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                {/* Continue with all other form fields... */}
                                <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '16px' }}>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Type de Revêtement *
                                        </label>
                                        <select name="flooringType" value={formData.flooringType} onChange={handleInputChange} required
                                                style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}>
                                            {flooringTypeOptions.map(type => (
                                                <option key={type.value} value={type.value}>{type.label}</option>
                                            ))}
                                        </select>
                                    </div>
                                    <div>
                                        <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                            Épaisseur
                                        </label>
                                        <input type="text" name="thickness" value={formData.thickness} onChange={handleInputChange}
                                               style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box' }}
                                        />
                                    </div>
                                </div>

                                <div>
                                    <label style={{ display: 'block', fontSize: '14px', fontWeight: '500', color: '#374151', marginBottom: '6px' }}>
                                        Description *
                                    </label>
                                    <textarea name="description" value={formData.description} onChange={handleInputChange} required rows="4" maxLength="1000"
                                              style={{ width: '100%', padding: '12px', border: '1px solid #d1d5db', borderRadius: '8px', fontSize: '14px', boxSizing: 'border-box', resize: 'vertical' }}
                                    />
                                    <small style={{ color: '#6b7280', fontSize: '12px' }}>
                                        {formData.description.length}/1000 caractères
                                    </small>
                                </div>
                            </div>

                            {/* Form Actions */}
                            <div style={{ display: 'flex', gap: '12px', marginTop: '24px', paddingTop: '20px', borderTop: '1px solid #e5e7eb' }}>
                                <button type="button" onClick={closeEditModal}
                                        style={{ flex: 1, padding: '12px 20px', border: '1px solid #d1d5db', background: 'white', color: '#374151', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: 'pointer' }}>
                                    Cancel
                                </button>
                                <button type="submit" disabled={isSubmitting}
                                        style={{ flex: 2, padding: '12px 20px', border: 'none', background: isSubmitting ? '#9ca3af' : '#f59e0b', color: 'white', borderRadius: '8px', fontSize: '14px', fontWeight: '500', cursor: isSubmitting ? 'not-allowed' : 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px' }}>
                                    {isSubmitting ? (
                                        <>
                                            <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                            Updating...
                                        </>
                                    ) : (
                                        <>
                                            <Edit style={{ width: '16px', height: '16px' }} />
                                            Update
                                        </>
                                    )}
                                </button>
                            </div>
                        </form>
                    </div>
                </div>
            )}

            {/* Sidebar */}
            <aside className="sidebar">
                <div className="sidebar-header">
                    <div
                        className="sidebar-logo-container"
                        onClick={() => navigate('/dashboard')}
                        style={{
                            cursor: 'pointer',
                            transition: 'all 0.2s ease',
                            borderRadius: '8px',
                            padding: '8px'
                        }}
                        onMouseEnter={(e) => {
                            e.currentTarget.style.backgroundColor = 'rgba(255, 255, 255, 0.1)';
                            e.currentTarget.style.transform = 'scale(1.02)';
                        }}
                        onMouseLeave={(e) => {
                            e.currentTarget.style.backgroundColor = 'transparent';
                            e.currentTarget.style.transform = 'scale(1)';
                        }}
                        title="Retour au Dashboard"
                    >
                        <div className="sidebar-logo">
                            <Building style={{ width: '24px', height: '24px', color: 'white' }} />
                        </div>
                        <div className="sidebar-brand">
                            <h1 className="sidebar-title">UNITECH IKK</h1>
                            <p className="sidebar-subtitle">Enterprise Dashboard</p>
                        </div>
                    </div>
                </div>

                <nav className="sidebar-nav">
                    {filteredMenuItems.map((item) => (
                        <div
                            key={item.id}
                            className={`nav-item ${activeMenuItem === item.id ? 'active' : ''}`}
                            onClick={() => {
                                setActiveMenuItem(item.id);
                                navigate(item.path);
                            }}
                        >
                            {item.isImage ? (
                                <img
                                    src={item.icon}
                                    alt={item.label}
                                    className="nav-icon-image"
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            ) : (
                                <item.icon
                                    style={{
                                        width: '20px',
                                        height: '20px',
                                        display: 'block'
                                    }}
                                />
                            )}
                            <span className="nav-text">{item.label}</span>
                        </div>
                    ))}
                </nav>

                <div className="sidebar-footer">
                    <div className="user-profile">
                        <div className="user-avatar">{getUserInitials()}</div>
                        <div className="user-info">
                            <p className="user-name">{getDisplayName()}</p>
                            <p className="user-role">{user?.role || 'Utilisateur'}</p>
                        </div>
                        <button
                            className="logout-button"
                            onClick={handleLogout}
                            title="Se déconnecter"
                        >
                            <LogOut style={{ width: '16px', height: '16px' }} />
                        </button>
                    </div>
                </div>
            </aside>

            {/* Main Content */}
            <main className="main-content">
                {/* Header */}
                <header className="header">
                    <div className="header-content">
                        <div className="header-left">
                            <button
                                className="menu-toggle"
                                onClick={() => setSidebarOpen(!sidebarOpen)}
                            >
                                {sidebarOpen ?
                                    <X style={{ width: '20px', height: '20px' }} /> :
                                    <Menu style={{ width: '20px', height: '20px' }} />
                                }
                            </button>

                            <nav className="breadcrumb">
                                <div className="breadcrumb-item">
                                    <Home style={{ width: '16px', height: '16px' }} />
                                    <span>Dashboard</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <FloorPlan style={{ width: '16px', height: '16px' }} />
                                    <span>Commercial Flooring Solutions</span>
                                </div>
                                <ChevronRight style={{ width: '14px', height: '14px' }} />
                                <div className="breadcrumb-item">
                                    <span>Products</span>
                                </div>
                            </nav>
                        </div>

                        <div className="header-right">
                            <div className="search-container">
                                <input
                                    type="text"
                                    className="search-input"
                                    placeholder="Research..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                <Search className="search-icon" style={{ width: '18px', height: '18px' }} />
                            </div>

                            <div className="header-actions">
                                <button
                                    className="header-button"
                                    onClick={handleRefresh}
                                    disabled={isLoading}
                                    title="Actualiser"
                                >
                                    <RefreshCw style={{
                                        width: '18px',
                                        height: '18px',
                                        transform: isLoading ? 'rotate(360deg)' : 'none',
                                        transition: 'transform 1s linear'
                                    }} />
                                </button>

                                <button
                                    className="header-button"
                                    title="Notifications"
                                >
                                    <Bell style={{ width: '18px', height: '18px' }} />
                                    {notifications.length > 0 && (
                                        <span className="notification-badge">{notifications.length}</span>
                                    )}
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/settings')}
                                    title="Paramètres système"
                                >
                                    <Settings style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/project_management')}
                                    title="Gestion de projets"
                                >
                                    <Folder style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/technical_support')}
                                    title="Technical Support"
                                >
                                    <MonitorCog style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/admin_support_it')}
                                    title="Admin Support IT"
                                >
                                    <SquareActivity style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/mytickets')}
                                    title="My Tickets"
                                >
                                    <Tickets style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/quotations')}
                                    title="Quotation System"
                                >
                                    <Receipt style={{ width: '18px', height: '18px' }} />
                                </button>

                                <button
                                    className="header-button"
                                    onClick={() => navigate('/clients')}
                                    title="Clients"
                                >
                                    <Briefcase style={{ width: '18px', height: '18px' }} />
                                </button>

                                <div className="time-display">
                                    {currentTime.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' })}
                                </div>
                            </div>
                        </div>
                    </div>
                </header>

                {/* Commercial Flooring Solutions Content */}
                <div className="products-content">
                    {/* Error Display */}
                    {error && (
                        <div className="error-message" style={{
                            background: '#fef2f2',
                            border: '1px solid #fecaca',
                            color: '#dc2626',
                            padding: '12px',
                            borderRadius: '8px',
                            marginBottom: '20px',
                            display: 'flex',
                            alignItems: 'center'
                        }}>
                            <AlertCircle style={{ width: '16px', height: '16px', marginRight: '8px' }} />
                            {error}
                        </div>
                    )}

                    {/* Page Header */}
                    <div className="page-header">
                        <h1 className="page-title">Commercial Flooring Solutions System</h1>
                        <p className="page-subtitle">
                            Manage your UNITECH IKK commercial flooring solutions inventory - Professional flooring systems for durability, aesthetics & performance.
                        </p>

                        <div className="page-actions">
                            <button
                                className="action-button"
                                onClick={openAddModal}
                                style={{ cursor: 'pointer' }}
                            >
                                <FloorPlan style={{ width: '16px', height: '16px' }} />
                                Add Flooring Solution
                            </button>
                            <button
                                className="action-button secondary"
                                onClick={handleExportCommercialFlooring}
                                disabled={isLoading}
                                title="Export all commercial flooring solutions"
                            >
                                {isLoading ? (
                                    <RefreshCw style={{ width: '16px', height: '16px', animation: 'spin 1s linear infinite' }} />
                                ) : (
                                    <Download style={{ width: '16px', height: '16px' }} />
                                )}
                                Export Catalogue
                            </button>
                            <button className="action-button secondary">
                                <ShoppingCart style={{ width: '16px', height: '16px' }} />
                                Quick Order
                            </button>
                        </div>
                    </div>

                    {/* Filters Section */}
                    <div className="filters-section">
                        <div className="filters-row">
                            <div className="filter-group">
                                <label className="filter-label">Research</label>
                                <input
                                    type="text"
                                    className="filter-input"
                                    placeholder="Product ID, barcode, description, flooring type..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Trier par</label>
                                <select
                                    className="filter-select"
                                    value={sortBy}
                                    onChange={(e) => setSortBy(e.target.value)}
                                >
                                    <option value="productId">Product ID</option>
                                    <option value="barcodeNumber">Barcode</option>
                                    <option value="flooringType">Flooring Type</option>
                                    <option value="fireRating">Fire Rating</option>
                                    <option value="warranty">Warranty</option>
                                    <option value="updatedAt">Last Updated</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Ordre</label>
                                <select
                                    className="filter-select"
                                    value={sortOrder}
                                    onChange={(e) => setSortOrder(e.target.value)}
                                >
                                    <option value="asc">Croissant</option>
                                    <option value="desc">Décroissant</option>
                                </select>
                            </div>

                            <div className="filter-group">
                                <label className="filter-label">Actions</label>
                                <button className="action-button secondary">
                                    <Filter style={{ width: '16px', height: '16px' }} />
                                    Filtres avancés
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Commercial Flooring Solutions Table */}
                    <div className="products-table-section">
                        <div className="table-header">
                            <h2 className="table-title">
                                Toutes les solutions de revêtement commercial
                            </h2>
                            <span className="table-stats">
                                {pagination.total} produit{pagination.total > 1 ? 's' : ''} trouvé{pagination.total > 1 ? 's' : ''}
                                {isLoading && ' (chargement...)'}
                            </span>
                        </div>

                        <table className="products-table">
                            <thead className="table-head">
                            <tr>
                                <th onClick={() => {
                                    setSortBy('barcodeNumber');
                                    setSortOrder(sortBy === 'barcodeNumber' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Code-barres {sortBy === 'barcodeNumber' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('productId');
                                    setSortOrder(sortBy === 'productId' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Product ID {sortBy === 'productId' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('flooringType');
                                    setSortOrder(sortBy === 'flooringType' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Type {sortBy === 'flooringType' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Spécifications</th>
                                <th onClick={() => {
                                    setSortBy('fireRating');
                                    setSortOrder(sortBy === 'fireRating' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Classement Feu {sortBy === 'fireRating' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('warranty');
                                    setSortOrder(sortBy === 'warranty' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Garantie {sortBy === 'warranty' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th onClick={() => {
                                    setSortBy('updatedAt');
                                    setSortOrder(sortBy === 'updatedAt' && sortOrder === 'asc' ? 'desc' : 'asc');
                                }} style={{ cursor: 'pointer' }}>
                                    Dernière MAJ {sortBy === 'updatedAt' && (sortOrder === 'asc' ? '↑' : '↓')}
                                </th>
                                <th>Actions</th>
                            </tr>
                            </thead>
                            <tbody className="table-body">
                            {flooringProducts.map((product) => {
                                const FlooringIcon = getFlooringTypeIcon(product.flooringType);
                                return (
                                    <tr key={product._id}>
                                        <td>
                                            <div className="barcode-info">
                                                <div className="barcode-number" style={{ fontFamily: 'monospace', fontWeight: '600' }}>
                                                    {product.barcodeNumber}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div>
                                                <div className="product-name" style={{ fontWeight: '500' }}>
                                                    {product.productId}
                                                </div>
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                                <FlooringIcon style={{ width: '16px', height: '16px', color: '#7c3aed' }} />
                                                <span style={{ fontSize: '13px', fontWeight: '500' }}>
                                                        {flooringTypeOptions.find(t => t.value === product.flooringType)?.label || product.flooringType}
                                                    </span>
                                            </div>
                                        </td>
                                        <td>
                                            <div style={{ fontSize: '12px', lineHeight: '1.4' }}>
                                                {product.thickness && <div><strong>Épaisseur:</strong> {product.thickness}</div>}
                                                {product.dimensions && <div><strong>Dimensions:</strong> {product.dimensions}</div>}
                                                {product.wearLayer && <div><strong>Couche d'usure:</strong> {product.wearLayer}</div>}
                                            </div>
                                        </td>
                                        <td>
                                                <span className="fire-rating-badge" style={{
                                                    backgroundColor: '#fef3c7',
                                                    color: '#d97706',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {product.fireRating?.replace('_', ' ') || 'N/A'}
                                                </span>
                                        </td>
                                        <td>
                                                <span className="warranty-badge" style={{
                                                    backgroundColor: '#dcfce7',
                                                    color: '#16a34a',
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    fontSize: '12px',
                                                    fontWeight: '500'
                                                }}>
                                                    {product.warranty?.replace('_', ' ') || 'N/A'}
                                                </span>
                                        </td>
                                        <td>
                                            {product.updatedAt ? new Date(product.updatedAt).toLocaleDateString('fr-FR') : '-'}
                                        </td>
                                        <td>
                                            <div className="actions-cell">
                                                <button
                                                    className="action-icon"
                                                    title="Voir détails"
                                                    onClick={() => openViewModal(product)}
                                                    style={{ cursor: 'pointer' }}
                                                >
                                                    <Eye style={{ width: '16px', height: '16px' }} />
                                                </button>
                                                {(user.role === 'manager' || user.role === 'admin') && (
                                                    <button
                                                        className="action-icon edit"
                                                        title="Modifier"
                                                        onClick={() => openEditModal(product)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Edit style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                                {user.role === 'admin' && (
                                                    <button
                                                        className="action-icon delete"
                                                        title="Supprimer"
                                                        onClick={() => handleDeleteFlooringProduct(product._id)}
                                                        style={{ cursor: 'pointer' }}
                                                    >
                                                        <Trash2 style={{ width: '16px', height: '16px' }} />
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    </tr>
                                );
                            })}
                            </tbody>
                        </table>

                        {flooringProducts.length === 0 && !isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b',
                                borderTop: '1px solid rgba(30, 64, 175, 0.05)'
                            }}>
                                <FloorPlan style={{ width: '48px', height: '48px', margin: '0 auto 16px', opacity: 0.5 }} />
                                <p style={{ fontSize: '16px', fontWeight: '500', marginBottom: '8px' }}>
                                    Aucune solution de revêtement commercial trouvée
                                </p>
                                <p style={{ fontSize: '14px' }}>
                                    Essayez de modifier vos critères de recherche ou filtres, ou ajoutez de nouvelles solutions UNITECH.
                                </p>
                            </div>
                        )}

                        {isLoading && (
                            <div style={{
                                padding: '40px',
                                textAlign: 'center',
                                color: '#64748b'
                            }}>
                                <RefreshCw style={{
                                    width: '24px',
                                    height: '24px',
                                    margin: '0 auto 16px',
                                    animation: 'spin 1s linear infinite'
                                }} />
                                <p>Chargement des solutions de revêtement commercial...</p>
                            </div>
                        )}

                        {/* Pagination */}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '20px',
                                display: 'flex',
                                justifyContent: 'center',
                                alignItems: 'center',
                                gap: '15px',
                                flexWrap: 'wrap',
                                borderTop: '1px solid #e5e7eb'
                            }}>
                                {/* Previous Button */}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.max(1, prev.page - 1) }))}
                                    disabled={pagination.page === 1}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === 1 ? '#f9fafb' : 'white',
                                        color: pagination.page === 1 ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === 1 ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    <ChevronRight style={{ width: '14px', height: '14px', transform: 'rotate(180deg)' }} />
                                    Précédent
                                </button>

                                {/* Page Numbers */}
                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '8px',
                                    background: '#f8fafc',
                                    padding: '8px 12px',
                                    borderRadius: '8px',
                                    border: '1px solid #e2e8f0'
                                }}>
                                    {Array.from({ length: Math.min(5, pagination.pages) }, (_, i) => {
                                        let page;
                                        if (pagination.pages <= 5) {
                                            page = i + 1;
                                        } else if (pagination.page <= 3) {
                                            page = i + 1;
                                        } else if (pagination.page >= pagination.pages - 2) {
                                            page = pagination.pages - 4 + i;
                                        } else {
                                            page = pagination.page - 2 + i;
                                        }

                                        return (
                                            <button
                                                key={page}
                                                onClick={() => setPagination(prev => ({ ...prev, page }))}
                                                style={{
                                                    padding: '6px 10px',
                                                    border: 'none',
                                                    borderRadius: '4px',
                                                    background: page === pagination.page ? '#7c3aed' : 'white',
                                                    color: page === pagination.page ? 'white' : '#374151',
                                                    cursor: 'pointer',
                                                    fontSize: '14px',
                                                    fontWeight: page === pagination.page ? '600' : '500',
                                                    minWidth: '32px',
                                                    transition: 'all 0.2s ease'
                                                }}
                                            >
                                                {page}
                                            </button>
                                        );
                                    })}
                                </div>

                                {/* Next Button */}
                                <button
                                    onClick={() => setPagination(prev => ({ ...prev, page: Math.min(prev.pages, prev.page + 1) }))}
                                    disabled={pagination.page === pagination.pages}
                                    style={{
                                        padding: '8px 12px',
                                        border: '1px solid #d1d5db',
                                        borderRadius: '6px',
                                        background: pagination.page === pagination.pages ? '#f9fafb' : 'white',
                                        color: pagination.page === pagination.pages ? '#9ca3af' : '#374151',
                                        cursor: pagination.page === pagination.pages ? 'not-allowed' : 'pointer',
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        transition: 'all 0.2s ease',
                                        display: 'flex',
                                        alignItems: 'center',
                                        gap: '6px'
                                    }}
                                >
                                    Suivant
                                    <ChevronRight style={{ width: '14px', height: '14px' }} />
                                </button>
                            </div>
                        )}

                        {/* Pagination Info */}
                        {pagination.pages > 1 && (
                            <div style={{
                                padding: '16px 20px',
                                backgroundColor: '#f8fafc',
                                borderTop: '1px solid #e5e7eb',
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                fontSize: '14px',
                                color: '#6b7280'
                            }}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <Database style={{ width: '16px', height: '16px' }} />
                                    <span>
                                        Affichage de {((pagination.page - 1) * pagination.limit) + 1} à {Math.min(pagination.page * pagination.limit, pagination.total)}
                                        sur {pagination.total} solutions de revêtement
                                    </span>
                                </div>

                                <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '12px',
                                    fontSize: '12px'
                                }}>
                                    <span style={{
                                        backgroundColor: '#e5e7eb',
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                        fontWeight: '500'
                                    }}>
                                        {pagination.limit} par page
                                    </span>
                                    <span>•</span>
                                    <span>Page {pagination.page}/{pagination.pages}</span>
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </main>
        </div>
    );
};

export default UnitechCommercialFlooringSolutionsPage;